import { Drawer, DrawerProps } from "@mui/material";
import React from "react";

export interface NonDismissibleDrawerProps
  extends Omit<DrawerProps, "onClose"> {
  onClose?: VoidFunction;
}

export const NonDismissibleDrawer: React.FC<NonDismissibleDrawerProps> = ({
  onClose,
  ...drawerProps
}) => {
  const handleCloseRequest: NonNullable<DrawerProps["onClose"]> = (
    _,
    reason,
  ): void => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;

    onClose?.();
  };

  return <Drawer {...drawerProps} onClose={handleCloseRequest} />;
};
